import { render, staticRenderFns } from "./BuildingDialog.vue?vue&type=template&id=caa0414e"
import script from "./BuildingDialog.vue?vue&type=script&lang=ts"
export * from "./BuildingDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports